import { fork } from "@redux-saga/core/effects";
import watchPatientActivities from "./watcher";

// This is the root saga which watches the all the actions triggered from the components
export default function* startWatching(){
    yield fork(watchPatientActivities);
}